import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTooltip]',
})
export class TooltipDirective {
  @Input() toolTipText: string;
  private tooltipElement: HTMLElement;
  private debounceTimeout: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    this.checkOverflow();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.removeTooltip();
  }

  @HostListener('window:resize') onResize() {
    if (this.tooltipElement) {
      this.removeTooltip();
      this.debounceCheckOverflow();
    }
  }

  @HostListener('window:scroll') onScroll() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      if (this.tooltipElement) {
        this.removeTooltip();
      }
    }, 130);
  }

  @HostListener('focusout', ['$event'])
  onFocusOut(event: FocusEvent) {
    const targetElement = event.relatedTarget as HTMLElement;
    if (this.tooltipElement && (!targetElement || !this.el.nativeElement.contains(targetElement))) {
      this.removeTooltip();
    }
  }

  private checkOverflow() {
    const element = this.el.nativeElement;
    const computedStyle = window.getComputedStyle(element);
    const lineClamp = computedStyle.getPropertyValue('-webkit-line-clamp');

    let isOverflowing = false;
    if (lineClamp && +lineClamp !== 1) {
      const lineHeight = parseFloat(computedStyle.getPropertyValue('line-height'));
      const maxHeight = lineHeight * parseInt(lineClamp, 10);
      const actualHeight = element.scrollHeight;
      isOverflowing = actualHeight > maxHeight;
    }
    if (element.scrollWidth > element.clientWidth) {
      isOverflowing = true;
    }
    if (isOverflowing) {
      if (this.tooltipElement) this.removeTooltip();
      this.tooltipElement = this.renderer.createElement('span');
      const text = this.renderer.createText(this.toolTipText);
      this.renderer.appendChild(this.tooltipElement, text);
      this.renderer.addClass(this.tooltipElement, 'customized-tooltip');
      this.renderer.appendChild(document.body, this.tooltipElement);

      const rect = this.el.nativeElement.getBoundingClientRect();
      const tooltipRect = this.tooltipElement.getBoundingClientRect();
      let top = rect.top - tooltipRect.height - 10;
      if (top < 0) {
        top = rect.bottom;
      }
      let left = rect.left;
      if (left + tooltipRect.width > window.innerWidth) {
        left = window.innerWidth - tooltipRect.width;
      }
      this.renderer.setStyle(this.tooltipElement, 'top', `${top}px`);
      this.renderer.setStyle(this.tooltipElement, 'left', `${left}px`);
      this.renderer.setStyle(this.tooltipElement, 'z-index', '9999');
    }
  }

  private debounceCheckOverflow() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => this.checkOverflow(), 200);
  }

  private removeTooltip() {
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
      this.tooltipElement = null;
    }
  }
}
